<template>
  <main>
    <background-wrapper src="policy-footer" ext="png">
      <container-small class="py-6">
        <div class="container">
          <div class="card py-2 px-3 py-sm-5 px-sm-6">
            <div class="header text-left mb-4">
              <h1>{{ $t('Feedback.header.title') }}</h1>
              <hr />
              <p class="mt-4">{{ $t('Feedback.header.hrdInvites') }}</p>
              <p v-html="$t('Feedback.header.pleaseUtilize')" />
              <p class="mt-4">{{ $t('Feedback.header.individuals') }}</p>

              <p class="mb-0"><strong>{{ $t('Feedback.header.online.title') }}</strong></p>
              <p v-html="$t('Feedback.header.online.description')" />

              <p class="mb-0"><strong>{{ $t('Feedback.header.person.title') }}</strong></p>
              <p v-html="$t('Feedback.header.person.description')" />

              <p class="mb-0"><strong>{{ $t('Feedback.header.writing.title') }}</strong></p>
              <p v-html="$t('Feedback.header.writing.description')" />

              <p class="mb-0"><strong>{{ $t('Feedback.header.telephone.title') }}</strong></p>
              <p v-html="$t('Feedback.header.telephone.description')" />

              <p class="mb-0"><strong>{{ $t('Feedback.header.email.title') }}</strong></p>
              <p v-html="$t('Feedback.header.email.description')" />

              <p v-html="$t('Feedback.header.note')" />
            </div>
            <template v-if="thankYou">
              <h3 class="text-center">Thank you for your submission!</h3>
            </template>
            <template v-else>
              <div class="partner-form">
              <h1 v-html="$t('Feedback.form.title')" />
              <hr />
              <div class="row">
                <div class="form-group col-md-12">
                  <div class="question" v-html="$t('Feedback.form.regarding.title')" />
                  <label v-for="(regard, value) in $t('Feedback.form.regarding.options')" :key="`regarding-${value}`" class="checkbox-label" :for="`regarding_${value}`">
                    <input v-model="form.regarding[value]" type="checkbox" name="regarding[]" :id="`regarding_${value}`" :value="regard">
                    <span v-html="regard" />
                  </label>

                  <div v-if="errors.regarding" class="error">The field is required</div>

                  <div class="form-group">
                    <label class="question" for="regardingComment" v-html="$t('Feedback.form.regarding.comment')" />
                    <textarea v-model="form.regardingComment" id="regardingComment" class="form-control" name="regardingComment"></textarea>
                  </div>

                  <div class="title" v-html="$t('Feedback.form.customerService.title')" />

                  <b-form-group v-slot="{ ariaDescribedby }">
                    <label class="question" v-html="$t('Feedback.form.customerService.satisfied.title')" />
                    <b-form-radio
                      v-model="form.satisfied"
                      v-for="(option, index) in $t('Feedback.form.customerService.satisfied.options')"
                      :key="`satisfied-${index}`"
                      :aria-describedby="ariaDescribedby"
                      name="satisfied-radio"
                      class="radio"
                      :value="option">
                        {{ option }}
                      </b-form-radio>
                  </b-form-group>

                  <div v-if="errors.satisfied" class="error">The field is required</div>

                  <div class="form-group">
                    <label for="satisfiedComment" v-html="$t('Feedback.form.customerService.satisfied.comment')" />
                    <textarea v-model="form.satisfiedComment" id="satisfiedComment" class="form-control" name="satisfiedComment"></textarea>
                  </div>

                  <b-form-group v-slot="{ ariaDescribedby }">
                    <label class="question" v-html="$t('Feedback.form.customerService.problems.title')" />
                    <b-form-radio
                      v-model="form.problems"
                      v-for="(option, index) in $t('Feedback.form.customerService.problems.options')"
                      :key="`problems-${index}`"
                      :aria-describedby="ariaDescribedby"
                      name="problems-radio"
                      class="radio"
                      :value="option">
                        {{ option }}
                      </b-form-radio>
                  </b-form-group>

                  <div v-if="errors.problems" class="error">The field is required</div>

                  <div class="form-group">
                    <label for="problemsComment" v-html="$t('Feedback.form.customerService.problems.comment')" />
                    <textarea v-model="form.problemsComment" id="problemsComment" class="form-control" name="problemsComment"></textarea>
                  </div>

                  <b-form-group v-slot="{ ariaDescribedby }">
                    <label class="question" v-html="$t('Feedback.form.customerService.accessible.title')" />
                    <b-form-radio
                      v-model="form.accessible"
                      v-for="(option, index) in $t('Feedback.form.customerService.accessible.options')"
                      :key="`accessible-${index}`"
                      :aria-describedby="ariaDescribedby"
                      name="accessible-radio"
                      class="radio"
                      :value="option">
                        {{ option }}
                      </b-form-radio>
                  </b-form-group>

                  <div v-if="errors.accessible" class="error">The field is required</div>

                  <div class="form-group">
                    <label for="accessibleComment" v-html="$t('Feedback.form.customerService.accessible.comment')" />
                    <textarea v-model="form.accessibleComment" id="accessibleComment" class="form-control" name="accessibleComment"></textarea>
                  </div>

                  <div class="title" v-html="$t('Feedback.form.contactInfo.title')" />

                  <p v-html="$t('Feedback.form.contactInfo.description')" />

                  <div class="form-group">
                    <label class="question" for="name" v-html="$t('Feedback.form.contactInfo.name')" />
                    <input v-model="form.name" type="text" class="form-control" id="name" name="name" :placeholder="$t('Feedback.form.contactInfo.placeholder')" value="">
                  </div>

                  <div class="form-group">
                    <label class="question" for="email" v-html="$t('Feedback.form.contactInfo.email')" />
                    <input v-model="form.email" type="email" class="form-control" id="email" name="email" :placeholder="$t('Feedback.form.contactInfo.placeholder')" value="">
                  </div>

                  <div class="form-group">
                    <label class="question" for="phone" v-html="$t('Feedback.form.contactInfo.phone')" />
                    <input v-model="form.phone" type="tel" class="form-control" id="phone" name="phone" :placeholder="$t('Feedback.form.contactInfo.placeholder')" value="">
                  </div>

                  <b-form-group v-slot="{ ariaDescribedby }">
                    <label class="question" v-html="$t('Feedback.form.contactInfo.correspondence.title')" />
                    <b-form-radio
                      v-model="form.correspondence"
                      v-for="(option, index) in $t('Feedback.form.contactInfo.correspondence.options')"
                      :key="`correspondence-${index}`"
                      :aria-describedby="ariaDescribedby"
                      name="correspondence-radio"
                      class="radio"
                      :value="option">
                        {{ option }}
                      </b-form-radio>
                  </b-form-group>

                  <div class="form-group">
                    <label for="correspondenceComments" v-html="$t('Feedback.form.contactInfo.correspondence.comments')" />
                    <textarea v-model="form.correspondenceComments" id="correspondenceComments" class="form-control" name="correspondenceComments"></textarea>
                  </div>

                  <p v-html="$t('Feedback.form.contactInfo.note')" />
                </div>
              </div>
              <div class="submit-container">
                <button class="btn btn-primary" :disabled="loading" @click="sendEmail">
                  <b-spinner v-if="loading" class="mr-1" small></b-spinner>
                  {{ $t('Feedback.form.submit') }}
                </button>
              </div>
            </div>
            </template>
          </div>
        </div>
      </container-small>
    </background-wrapper>
  </main>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Feedback',
  data () {
    return {
      thankYou: false,
      loading: false,
      form: {
        regarding: {
          comments: false,
          feedback: false,
          documents: false,
          general: false
        },
        regardingComment: '',
        satisfied: '',
        satisfiedComment: '',
        problems: '',
        problemsComment: '',
        accessible: '',
        accessibleComment: '',
        name: '',
        email: '',
        phone: '',
        correspondence: '',
        correspondenceComments: ''
      },
      errors: {
        regarding: false,
        satisfied: false,
        problems: false,
        accessible: false
      }
    }
  },
  computed: {
    isFormValid () {
      return !Object.keys(this.errors).some(k => this.errors[k])
    },

    feedbackReasons () {
      const reasons = []
      for (const reason in this.form.regarding) {
        if (this.form.regarding[reason]) {
          reasons.push(this.$t(`Feedback.form.regarding.options.${reason}`))
        }
      }

      return reasons.join('\n')
    }
  },
  methods: {
    validate () {
      this.errors.regarding = !this.validateRegarding(this.form.regarding)
      this.errors.satisfied = this.form.satisfied.length === 0
      this.errors.problems = this.form.problems.length === 0
      this.errors.accessible = this.form.accessible.length === 0
    },

    validateRegarding (options) {
      return Object.values(options).some(Boolean)
    },

    sendEmail () {
      this.validate()

      if (this.isFormValid) {
        this.loading = true
        const emailBody = `
          Name: ${this.form.name} \n
          Email: ${this.form.email} \n
          Phone: ${this.form.phone} \n\n
          Contact method: ${this.form.correspondence} \n
          Contact method comment: ${this.form.correspondenceComments} \n\n
          Feedback reasons: \n
          ${this.feedbackReasons} \n\n
          Comments/Questions/Suggestions: ${this.form.regardingComment} \n\n
          Satisfactory: ${this.form.satisfied} \n
          Satisfactory comment: ${this.form.satisfiedComment} \n\n
          Problem accessing our service: ${this.form.problems} \n
          Problem accessing our service comment: ${this.form.problemsComment} \n\n
          Service accessibility: ${this.form.accessible} \n
          Service accessibility comment: ${this.form.accessibleComment} \n\n
        `

        let data = new FormData()
        data.append('from', process.env['EMAIL_FROM'])
        data.append('to', process.env['FEEDBACK_ADDRESS'])
        data.append('subject', 'HRdownloads Accessibility Feedback Form Submission')
        data.append('body', emailBody)

        axios.post(`${process.env['CMS_DOMAIN']}/api/contact`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => {
            this.showThankYou()
          })
          .catch(err => console.log(err))
          .finally(() => {
            this.loading = false
          })
      }
    },

    showThankYou () {
      this.thankYou = true
    }
  }
}
</script>

<style lang="sass" scoped>
.error
  color: red

.checkbox-label
  padding: 5px 0 5px 2em
  text-indent: -1em

  input
    margin-right: 1em
    margin-left: -1em

.title
  font-size: 24px
  font-weight: 900
  line-height: 1.33
  color: #383b41
  margin: 50px 0 25px

.question
  font-size: 16px
  font-weight: bold
  line-height: 1.5
  letter-spacing: 0.2px
  color: #28292b
  margin: 30px 0 20px

.radio
  margin-bottom: 0.5rem
  padding: 5px 1.5rem
</style>



// WEBPACK FOOTER //
// src/components/accessibility/Feedback.vue